const maniFestInProgressViewDetails = {
  manifestInProgressList: [
    {
      trailerId: "TRAILER#1",
      mainfestId: "MID#123",
      totalPallets: "20",
      deliveryStores: "02",
      startLocation: "Idaho Falls, IDHAO, US",
      endLocation: "Idaho Falls, IDHAO, US",
      stores: [
        {
          name: "STORE#1",
          area: "Nebraska, 80831, US",
          count: "04",
          pallets: [
            {
              id: "1",
              name: "PID#34522",
              trackerId: "TID#3421",
              palletId: "PID#34522",
              status: "In Transit",
              dispatchedDate: "03-13-2023 | 9:00 AM",
              deliveredDate: "13-03-2023 | 11:00 AM",
              temparature: "68°C",
              humidity: "24%",
              pressure: "987 kPa",
              palletShipmentData: [
                {
                  id: "1",
                  packageStage: "Pallet Ready For Shipment",
                  timeStamp: "1-11-2023 9.00AM",
                  status: "Completed",
                },
                {
                  id: "2",
                  packageStage: "Left Grocery Warehouse#1",
                  timeStamp: "1-11-2023 10.30AM",
                  status: "Completed",
                },
                {
                  id: "3",
                  packageStage: "In Transit",
                  timeStamp: "1-11-2023 12.30PM",
                  status: "In progress",
                },
                {
                  id: "4",
                  packageStage: "Store#1",
                  timeStamp: "1-11-2023 1.30PM",
                  status: "In progress",
                },
              ],
            },
            {
              id: "2",
              name: "PID#34523",
              trackerId: "TID#3421",
              palletId: "PID#34523",
              status: "In Transit",
              dispatchedDate: "03-13-2023 | 9:00 AM",
              deliveredDate: "13-03-2023 | 11:00 AM",
              temparature: "68°C",
              humidity: "24%",
              pressure: "987 kPa",
              palletShipmentData: [
                {
                  id: "1",
                  packageStage: "Pallet Ready For Shipment",
                  timeStamp: "1-11-2023 9.00AM",
                  status: "Completed",
                },
                {
                  id: "2",
                  packageStage: "Left Grocery Warehouse#1",
                  timeStamp: "1-11-2023 10.30AM",
                  status: "Completed",
                },
                {
                  id: "3",
                  packageStage: "In Transit",
                  timeStamp: "1-11-2023 12.30PM",
                  status: "In progress",
                },
                {
                  id: "4",
                  packageStage: "Store#1",
                  timeStamp: "1-11-2023 1.30PM",
                  status: "In progress",
                },
              ],
            },
            {
              id: "3",
              name: "PID#34524",
              trackerId: "TID#3421",
              palletId: "PID#34524",
              status: "In Transit",
              dispatchedDate: "03-13-2023 | 9:00 AM",
              deliveredDate: "13-03-2023 | 11:00 AM",
              temparature: "68°C",
              humidity: "24%",
              pressure: "987 kPa",

              palletShipmentData: [
                {
                  id: "1",
                  packageStage: "Pallet Ready For Shipment",
                  timeStamp: "1-11-2023 9.00AM",
                  status: "Completed",
                },
                {
                  id: "2",
                  packageStage: "Left Grocery Warehouse#1",
                  timeStamp: "1-11-2023 10.30AM",
                  status: "Completed",
                },
                {
                  id: "3",
                  packageStage: "In Transit",
                  timeStamp: "1-11-2023 12.30PM",
                  status: "In progress",
                },
                {
                  id: "4",
                  packageStage: "Store#1",
                  timeStamp: "1-11-2023 1.30PM",
                  status: "In progress",
                },
              ],
            },
            {
              id: "4",
              name: "PID#34525",
              trackerId: "TID#3421",
              palletId: "PID#34525",
              status: "In Transit",
              dispatchedDate: "03-13-2023 | 9:00 AM",
              deliveredDate: "13-03-2023 | 11:00 AM",
              temparature: "68°C",
              humidity: "24%",
              pressure: "987 kPa",
              palletShipmentData: [
                {
                  id: "1",
                  packageStage: "Pallet Ready For Shipment",
                  timeStamp: "1-11-2023 9.00AM",
                  status: "Completed",
                },
                {
                  id: "2",
                  packageStage: "Left Grocery Warehouse#1",
                  timeStamp: "1-11-2023 10.30AM",
                  status: "Completed",
                },
                {
                  id: "3",
                  packageStage: "In Transit",
                  timeStamp: "1-11-2023 12.30PM",
                  status: "In progress",
                },
                {
                  id: "4",
                  packageStage: "Store#1",
                  timeStamp: "1-11-2023 1.30PM",
                  status: "In progress",
                },
              ],
            },
          ],
        },
        {
          name: "STORE#2",
          area: "Missouri, 80831, US",
          count: "04",
          pallets: [
            {
              id: "1",
              name: "PID#34524",
              trackerId: "TID#3421",
              palletId: "PID#34524",
              status: "In Transit",
              dispatchedDate: "03-13-2023 | 9:00 AM",
              deliveredDate: "13-03-2023 | 11:00 AM",
              temparature: "68°C",
              humidity: "24%",
              pressure: "987 kPa",
              palletShipmentData: [
                {
                  id: "1",
                  packageStage: "Pallet Ready For Shipment",
                  timeStamp: "1-11-2023 9.00AM",
                  status: "Completed",
                },
                {
                  id: "2",
                  packageStage: "Left Grocery Warehouse#1",
                  timeStamp: "1-11-2023 10.30AM",
                  status: "Completed",
                },
                {
                  id: "3",
                  packageStage: "In Transit",
                  timeStamp: "1-11-2023 12.30PM",
                  status: "In progress",
                },
                {
                  id: "4",
                  packageStage: "Store#1",
                  timeStamp: "1-11-2023 1.30PM",
                  status: "In progress",
                },
              ],
            },
            {
              id: "2",
              name: "PID#34525",
              trackerId: "TID#3421",
              palletId: "PID#34525",
              status: "In Transit",
              dispatchedDate: "03-13-2023 | 9:00 AM",
              deliveredDate: "13-03-2023 | 11:00 AM",
              temparature: "68°C",
              humidity: "24%",
              pressure: "987 kPa",
              palletShipmentData: [
                {
                  id: "1",
                  packageStage: "Pallet Ready For Shipment",
                  timeStamp: "1-11-2023 9.00AM",
                  status: "Completed",
                },
                {
                  id: "2",
                  packageStage: "Left Grocery Warehouse#1",
                  timeStamp: "1-11-2023 10.30AM",
                  status: "Completed",
                },
                {
                  id: "3",
                  packageStage: "In Transit",
                  timeStamp: "1-11-2023 12.30PM",
                  status: "In progress",
                },
                {
                  id: "4",
                  packageStage: "Store#1",
                  timeStamp: "1-11-2023 1.30PM",
                  status: "In progress",
                },
              ],
            },
            {
              id: "3",
              name: "PID#34526",
              trackerId: "TID#3421",
              palletId: "PID#34526",
              status: "In Transit",
              dispatchedDate: "03-13-2023 | 9:00 AM",
              deliveredDate: "13-03-2023 | 11:00 AM",
              temparature: "68°C",
              humidity: "24%",
              pressure: "987 kPa",
              palletShipmentData: [
                {
                  id: "1",
                  packageStage: "Pallet Ready For Shipment",
                  timeStamp: "1-11-2023 9.00AM",
                  status: "Completed",
                },
                {
                  id: "2",
                  packageStage: "Left Grocery Warehouse#1",
                  timeStamp: "1-11-2023 10.30AM",
                  status: "Completed",
                },
                {
                  id: "3",
                  packageStage: "In Transit",
                  timeStamp: "1-11-2023 12.30PM",
                  status: "In progress",
                },
                {
                  id: "4",
                  packageStage: "Store#1",
                  timeStamp: "1-11-2023 1.30PM",
                  status: "In progress",
                },
              ],
            },
            {
              id: "4",
              name: "PID#34527",
              trackerId: "TID#3421",
              palletId: "PID#34527",
              status: "In Transit",
              dispatchedDate: "03-13-2023 | 9:00 AM",
              deliveredDate: "13-03-2023 | 11:00 AM",
              temparature: "68°C",
              humidity: "24%",
              pressure: "987 kPa",
              palletShipmentData: [
                {
                  id: "1",
                  packageStage: "Pallet Ready For Shipment",
                  timeStamp: "1-11-2023 9.00AM",
                  status: "Completed",
                },
                {
                  id: "2",
                  packageStage: "Left Grocery Warehouse#1",
                  timeStamp: "1-11-2023 10.30AM",
                  status: "Completed",
                },
                {
                  id: "3",
                  packageStage: "In Transit",
                  timeStamp: "1-11-2023 12.30PM",
                  status: "In progress",
                },
                {
                  id: "4",
                  packageStage: "Store#1",
                  timeStamp: "1-11-2023 1.30PM",
                  status: "In progress",
                },
              ],
            },
          ],
        },
      ],
      trailerRoutes: [
        {
          name: "WAREHOUSE#1",
          status: "In progress",
          area: "Idaho Falls, IDHAO, US ",
          
          timeStamp: "02-13-2023 | 9:00 AM",
        },
        {
          name: "WYOMING",
          status: "In progress",
          area: "San Carlos, Costa Rica",
          
          timeStamp: "02-13-2023 | 9:00 AM",
        },
        {
          name: "STORE#1",
          status: "In progress",
          area: "Nebraska, 80831, US ",
          
          timeStamp: "02-13-2023 | 9:00 AM",
        },
        {
            name: "STORE#2",
            status: "In progress",
            area: "Idaho Falls, IDHAO, US ",
            
            timeStamp: "03-13-2023 | 1:30 PM",
          },
      ],
    },
  ],
};

export default maniFestInProgressViewDetails;
